module.exports = __webpack_public_path__ + "static/bnr_wide@2x-8c8ac1fb6b428d583a8e3c0fe6005444.png";